import React from 'react';

import { Text } from '@mantine/core';
import { RichTextEditor } from '@mantine/tiptap';

export type RichTextBoldControlProps = Omit<React.ComponentProps<typeof RichTextEditor.Bold>, 'icon'>;

/**
 * `RichTextEditor.Bold` with its glyph rendered in bold weight instead of Mantine's default outline
 * icon, so the control reads as "bold" at a glance. Drop-in replacement — forwards all other props.
 *
 * Must be rendered inside a `<RichTextEditor>` toolbar (it relies on Mantine's editor context).
 *
 * @example
 * <RichTextEditor.Toolbar>
 *   <RichTextEditor.ControlsGroup>
 *     <RichTextBoldControl />
 *     <RichTextEditor.Italic />
 *   </RichTextEditor.ControlsGroup>
 * </RichTextEditor.Toolbar>
 */
const RichTextBoldControl = (props: RichTextBoldControlProps): JSX.Element => (
  <RichTextEditor.Bold
    {...props}
    icon={() => (
      <Text component='span' fw={700} fz='sm' lh={1}>
        B
      </Text>
    )}
  />
);

export default RichTextBoldControl;
